import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export default function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("hi") ? "hi" : "en";

  const setLang = (lng: "en" | "hi") => {
    if (lng !== current) i18n.changeLanguage(lng);
  };

  return (
    <div
      className={`inline-flex items-center rounded-full border border-border bg-white/80 ${
        compact ? "p-0.5" : "p-1"
      }`}
      role="group"
      aria-label="Language"
      data-testid="language-switcher"
    >
      <Button
        type="button"
        variant="ghost"
        onClick={() => setLang("en")}
        className={`rounded-full h-7 px-3 text-xs font-semibold ${
          current === "en"
            ? "bg-primary text-primary-foreground hover:bg-primary"
            : "text-muted-foreground hover:bg-muted"
        }`}
        data-testid="lang-en"
        aria-pressed={current === "en"}
      >
        EN
      </Button>
      <Button
        type="button"
        variant="ghost"
        onClick={() => setLang("hi")}
        className={`rounded-full h-7 px-3 text-xs font-semibold ${
          current === "hi"
            ? "bg-primary text-primary-foreground hover:bg-primary"
            : "text-muted-foreground hover:bg-muted"
        }`}
        data-testid="lang-hi"
        aria-pressed={current === "hi"}
      >
        हिं
      </Button>
    </div>
  );
}
